// import React, { useState } from "react";

import { Calendar, Mail, MessageSquare, Phone, User, Users } from "lucide-react";
import Wave from "react-wavify";
// import ReservationForm from "../../components/page/ReservationForm";

const Reserveer: React.FC = () => {
    // const [isOpen, setIsOpen] = useState(false);

    return (
        <div id="reserveer" className="bg-[#9a3415]">
            <div>
                <div className="bg-[#f8f6e3]">
                    <Wave fill='#9a3415'
                          paused={true}
                          style={{display: 'flex'}}
                          options={{
                              height: 70,
                              amplitude: 50,
                              speed: 0.15,
                              points: 3
                          }}
                    />
                </div>
                <div className="max-w-6xl mx-auto">
                    <h1 className={"font-black text-5xl text-center text-[#f8f6e3]"}>Reserveer</h1>
                    
                    {/* Info Section */}
                    <div className="px-4 md:px-0 py-8">
                        <div className="bg-[#f8f6e3] rounded-2xl p-6 md:p-8 mb-8">
                            <p className="text-center text-lg md:text-xl text-[#9a3415] font-semibold mb-4">
                                Reserveren via mail, minstens 48 uur op voorhand
                            </p>
                            <p className="text-center text-gray-700">
                                Geldig enkel na e-mailbevestiging door ons (dit kan tot 48 uur duren)
                            </p>
                            <p className="text-center text-gray-700">
                                We hebben de volgende gegevens van je nodig:
                            </p>
                            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 md:gap-3 mb-6">
                                {[
                                    { icon: User, label: 'Naam' },
                                    { icon: Phone, label: 'Telefoon' },
                                    { icon: Calendar, label: 'Datum & uur' },
                                    { icon: Users, label: 'Personen' },
                                    { icon: MessageSquare, label: 'Opmerkingen' }
                                ].map((item, idx) => (
                                    <div key={idx} className="bg-[#f8f6e3] rounded-xl p-3 md:p-4 flex flex-col items-center gap-2 text-center">
                                        <item.icon size={20} className="text-[#9a3415] md:w-6 md:h-6" />
                                        <span className="font-semibold text-[#9a3415] text-xs md:text-sm">{item.label}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="bg-[#f8f6e3] rounded-xl p-3 md:p-4 text-center">
                                <p className="text-gray-700 text-xs md:text-sm">
                                    <span className="font-semibold">💡 Tip:</span> We reserveren nooit op het terras, maar mag je daar altijd gaan zitten!
                                </p>
                            </div>
                            <div className="text-center">
                            <a 
                                href="mailto:contact@bar-elvire.be"
                                className="inline-flex items-center gap-2 bg-[#9a3415] text-[#f8f6e3] font-bold py-3 px-8 rounded-xl transition-colors duration-200 shadow-lg hover:bg-[#661f09] hover:shadow-xl"
                            >
                                <Mail size={24} />
                                contact@bar-elvire.be
                            </a>
                        </div>
                            
                        </div>

                        {/* Email CTA */}
                        <div className="text-center">
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reserveer;